import { effect, inject, Injectable, signal } from '@angular/core';
import { TestingAccessService } from './testing-access.service';

@Injectable({
    providedIn: 'root',
})
export class SubstepValidationToggleService {
    private readonly STORAGE_KEY = 'isi-dtc-enable-substep-validation';
    private testingAccess = inject(TestingAccessService);

    isValidationEnabled = signal<boolean>(true);

    constructor() {
        if (this.testingAccess.isEnabled()) {
            this.initializeState();

            effect(() => {
                const enabled = this.isValidationEnabled();
                localStorage.setItem(this.STORAGE_KEY, JSON.stringify(enabled));
            });
        }
    }

    private initializeState() {
        const stored = localStorage.getItem(this.STORAGE_KEY);
        if (stored !== null) {
            this.isValidationEnabled.set(JSON.parse(stored));
        }
    }

    toggle() {
        this.isValidationEnabled.update((enabled) => !enabled);
    }
}
